import { useState } from 'react';

export default function useToggle(initialOn = false) {
  const [on, setToggle] = useState(initialOn);

  return {
    on,
    toggle: () => setToggle(!on),
    open: () => setToggle(true),
    close: () => setToggle(false),
  };
}



// WEBPACK FOOTER //
// ./src/hooks/useToggle.js